import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { Box } from '@atlaskit/primitives';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { FormattedMessage } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from '../../../messages';
import { useTeamPermissions } from '../../../services/use-team-permissions';
import teamPickerEmptyStateIcon from './assets/team-picker-empty-state.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.p({
	color: token('color.text', N500),
	marginBottom: token('space.300', '24px'),
	marginTop: token('space.0', '0px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	marginBottom: token('space.200', '16px'),
});

type TeamPickerEmptyStateProps = {
	onActionClick: () => void;
};

export const TeamPickerEmptyState = ({ onActionClick }: TeamPickerEmptyStateProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { canCreateTeams } = useTeamPermissions();

	const handleCreateTeamOptionClick = () => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
			teamsFieldEmptyState: true,
		});
		onActionClick();
	};

	return canCreateTeams ? (
		<Box
			paddingBlock="space.200"
			testId="issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
		>
			<Image src={teamPickerEmptyStateIcon} alt="" />
			<Description>
				<FormattedMessage {...messages.emptyStateDescription} />
			</Description>
			<Button
				appearance="primary"
				onClick={handleCreateTeamOptionClick}
				testId="issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button"
				interactionName="auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
			>
				<FormattedMessage {...messages.createTeamButtonText} />
			</Button>
		</Box>
	) : (
		<FormattedMessage {...messages.noOptionsMessage} />
	);
};
